(() => {
  const STAR_COUNT = 5;
  const REVIEW_COUNT = "90,000+";
  const BLOCK_CLASS = "custom-rating-block-v1";
  const EXPID = "WUN-11";

  // Error handling utility
  const ErrorHandler = {
    log: (error, context = '') => {
      console.error(`[${EXPID}] Error${context ? ` in ${context}` : ''}:`, error);
    },

    safeExecute: (fn, context = '', fallback = null) => {
      try {
        return fn();
      } catch (error) {
        ErrorHandler.log(error, context);
        return fallback;
      }
    },

    validateElement: (element, selector, context = '') => {
      if (!element) {
        ErrorHandler.log(new Error(`Element not found: ${selector}`), context);
        return false;
      }
      return true;
    }
  };

  const starSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M7.99991 13.2155L4.48466 15.0635C3.72716 15.4617 2.84216 14.819 2.98616 13.9752L3.65741 10.0602L0.813414 7.28675C0.199914 6.68975 0.538164 5.64875 1.38491 5.52425L5.31641 4.95425L7.07366 1.39175C7.45241 0.622998 8.54666 0.622998 8.92616 1.39175L10.6834 4.95425L14.6149 5.52425C15.4617 5.648 15.7999 6.68825 15.1872 7.28675L12.3424 10.0602L13.0137 13.9752C13.1577 14.819 12.2727 15.4625 11.5152 15.0635L7.99991 13.2155Z" fill="url(#paint0_linear_10014_180)"/><defs><linearGradient id="paint0_linear_10014_180" x1="7.99991" y1="0.814998" x2="7.99991" y2="15.185" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE61C"/><stop offset="1" stop-color="#FFA929"/></linearGradient></defs></svg>`;
  const greyStarSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M7.99991 13.2155L4.48466 15.0635C3.72716 15.4617 2.84216 14.819 2.98616 13.9752L3.65741 10.0602L0.813414 7.28675C0.199914 6.68975 0.538164 5.64875 1.38491 5.52425L5.31641 4.95425L7.07366 1.39175C7.45241 0.622998 8.54666 0.622998 8.92616 1.39175L10.6834 4.95425L14.6149 5.52425C15.4617 5.648 15.7999 6.68825 15.1872 7.28675L12.3424 10.0602L13.0137 13.9752C13.1577 14.819 12.2727 15.4625 11.5152 15.0635L7.99991 13.2155Z" fill="#E0E0E0"/></svg>`;
  
  const halfStarSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><defs><linearGradient id="paint0_linear_10014_180" x1="8" y1="0.815" x2="8" y2="15.185" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE61C"/><stop offset="1" stop-color="#FFA929"/></linearGradient><clipPath id="clip-half-star"><rect x="0" y="0" width="8" height="16"/></clipPath></defs><g clip-path="url(#clip-half-star)"><path d="M7.99991 13.2155L4.48466 15.0635C3.72716 15.4617 2.84216 14.819 2.98616 13.9752L3.65741 10.0602L0.813414 7.28675C0.199914 6.68975 0.538164 5.64875 1.38491 5.52425L5.31641 4.95425L7.07366 1.39175C7.45241 0.622998 8.54666 0.622998 8.92616 1.39175L10.6834 4.95425L14.6149 5.52425C15.4617 5.648 15.7999 6.68825 15.1872 7.28675L12.3424 10.0602L13.0137 13.9752C13.1577 14.819 12.2727 15.4625 11.5152 15.0635L7.99991 13.2155Z" fill="url(#paint0_linear_10014_180)"/></g><path d="M7.99991 13.2155L4.48466 15.0635C3.72716 15.4617 2.84216 14.819 2.98616 13.9752L3.65741 10.0602L0.813414 7.28675C0.199914 6.68975 0.538164 5.64875 1.38491 5.52425L5.31641 4.95425L7.07366 1.39175C7.45241 0.622998 8.54666 0.622998 8.92616 1.39175L10.6834 4.95425L14.6149 5.52425C15.4617 5.648 15.7999 6.68825 15.1872 7.28675L12.3424 10.0602L13.0137 13.9752C13.1577 14.819 12.2727 15.4625 11.5152 15.0635L7.99991 13.2155Z" stroke="url(#paint0_linear_10014_180)" stroke-width="1"/></svg>`;

  const asset = [
    {
      stars: `${starSVG}${starSVG}${starSVG}${starSVG}${starSVG}`,
      title: "Bester Gutschein überhaupt",
      description: "Damit macht man nichts verkehrt. Der beschenkte kann das Guthaben einfach für einen Einkauf in seinem Wunschshop verwenden. Die Shopauswahl ist riesig und für jeden was dabei. Das einlösen bzw. Umwandeln ist auch total einfach und geht schnell. <br><br> <span>Ich freu mich immer über Wunschgutscheine 🍀</span>",
      author: "Mary S."
    },
    {
      stars: `${starSVG}${starSVG}${starSVG}${starSVG}${starSVG}`,
      title: "Einfach praktisch mit großer Auswahl",
      description: "Nicht einfach nur ein Tankgutschein oder Betrag bei Amazon. Der Beschenkte kann wählen und sieht schöner aus als Bargeld.",
      author: "Mich Ael"
    },
    {
      stars: `${starSVG}${starSVG}${starSVG}${starSVG}${greyStarSVG}`,
      title: "Toll und unkompliziert !",
      description: "Gute Geschenkidee, online & offline einlösbar! Bestellung und Erhalt super schnell. Weiterzuempfehlen.",
      author: "Diana Lange"
    }
  ];

  function waitFor(selector, callback, limit = 30) {
    return ErrorHandler.safeExecute(() => {
      const intv = setInterval(() => {
        try {
          const el = document.querySelector(selector);
          if (el) {
            clearInterval(intv);
            callback(el);
          } else if (--limit < 0) {
            clearInterval(intv);
            ErrorHandler.log(new Error(`Timeout waiting for selector: ${selector}`), 'waitFor');
          }
        } catch (error) {
          clearInterval(intv);
          ErrorHandler.log(error, 'waitFor');
        }
      }, 200);
    }, 'waitFor');
  }

  function createRatingSummaryBlock() {
    return ErrorHandler.safeExecute(() => {
      let starsHTML = '';
      for (let i = 0; i < 4; i++) starsHTML += starSVG;
      starsHTML += greyStarSVG;

      return `
        <div class="${BLOCK_CLASS}" style="display:flex;align-items:center;gap:6px;line-height:1;font-size:15px;align-self:flex-start;margin-top:2px;cursor:pointer;">
    <span style="display:flex;gap:2px;height:16px;">${starsHTML}</span>
    <span style="color:#333;">${REVIEW_COUNT}</span>
    <span class="rating-source">Bewertungen auf Trustpilot</span>
  </div>
      `;
    }, 'createRatingSummaryBlock', '');
  }

  function createReviewSection() {
    return ErrorHandler.safeExecute(() => {
      const isMobile = window.innerWidth < 768;

      const wrapperStyle = isMobile
        ? "flex-direction: column; align-items: center; gap: 24px; max-width: 680px; margin: 0 auto;"
        : "flex-direction: row; flex-wrap: wrap; justify-content: center; gap: 24px;";

      const cardStyle = isMobile
        ? "width: 100%;"
        : "width: 30%; min-width: 260px; max-width: 320px; flex: 1;";

      return `
        <div id="testimonial-section" style="margin: 32px auto;">
          <div class="${EXPID}-review-section" style="display: flex; ${wrapperStyle}">
            ${asset.map(r => `
              <div class="${EXPID}-review-card" style="${cardStyle} display:flex;flex-direction:column;justify-content:space-between;height:100%;padding:20px 24px;background:#fff;border-radius:10px;box-shadow:0 1px 8px rgba(0,0,0,0.04);">
                <div class="review-content-wrapper">
                  <div class="${EXPID}-stars" style="margin-bottom:6px;">${r.stars}</div>
                  <div class="${EXPID}-review-title" style="font-weight:700;">${r.title}</div>
                  <div class="${EXPID}-review-content" style="margin:10px 0 0 0;">${r.description}</div>
                </div>
                <div class="${EXPID}-review-author" style="margin-top:16px;font-weight:600;">${r.author}</div>
              </div>
            `).join('')}
          </div>
          <p id="testimonial-desc">Auf dieser Seite werden ausschließlich ausgewählte positive Kundenbewertungen dargestellt. Diese stellen keine vollständige Übersicht aller erhaltenen Rückmeldungen dar. Eine Überprüfung der Bewertungen auf Echtheit durch uns erfolgt nicht.</p>
        </div>`;
    }, 'createReviewSection', '');
  }

  // Fix price layout to put "+ 1.90 Motiv" next to the main price
  function fixPriceLayout() {
    return ErrorHandler.safeExecute(() => {
      // Find all the elements in order
      const plusSeparator = document.querySelector('.price-plus-seperator');
      const allPriceContainers = document.querySelectorAll('.price.price--large');
      const motivLabel = document.querySelector('.motiv-price-label');
      const mainPriceContainer = allPriceContainers[0]; // First one should be 50€
      const motivPriceContainer = allPriceContainers[1]; // Second one should be 1,90€

      // Ensure all elements exist
      if (!plusSeparator || allPriceContainers.length < 2 || !motivLabel || !mainPriceContainer || !motivPriceContainer) {
        console.log(`[${EXPID}] Price elements not found correctly for side-by-side layout`, {
          plusSeparator: !!plusSeparator,
          priceContainers: allPriceContainers.length,
          motivLabel: !!motivLabel,
          mainPriceContainer: !!mainPriceContainer,
          motivPriceContainer: !!motivPriceContainer
        });
        return;
      }

      // Get the parent of the main price container
      const parentElement = mainPriceContainer.parentNode;

      if (!parentElement) {
        ErrorHandler.log(new Error('Main price container has no parent'), 'fixPriceLayout');
        return;
      }

      // Ensure they are displayed (they might have been hidden by previous logic or default styles)
      plusSeparator.style.removeProperty('display'); // Revert to default display
      motivPriceContainer.style.removeProperty('display'); // Revert to default display
      motivLabel.style.removeProperty('display'); // Revert to default display

      // Ensure there are no interfering margins or paddings that would push them to a new line
      // ADDED: margin-right to plusSeparator for space after '+'
      plusSeparator.style.cssText = `margin: 0 4px 0 4px !important;`; // Adds 4px margin to left and right
      motivPriceContainer.style.margin = '0';
      motivLabel.style.margin = '0 0 0 4px'; // Add a small left margin for spacing

      // Append them in order to the parent of the main price.
      // If they are already in the correct parent, this will reorder them.
      parentElement.appendChild(plusSeparator);
      parentElement.appendChild(motivPriceContainer);
      parentElement.appendChild(motivLabel);

      console.log(`[${EXPID}] Price layout fixed successfully for side-by-side display`);
    }, 'fixPriceLayout');
  }

  function injectSummaryRating(price) {
    return ErrorHandler.safeExecute(() => {
      if (!ErrorHandler.validateElement(price, 'price element', 'injectSummaryRating')) return;

      if (document.querySelector('.' + BLOCK_CLASS)) return;

      const ratingHTML = createRatingSummaryBlock();
      if (!ratingHTML) return;

      const wrapper = document.createElement('div');
      wrapper.innerHTML = ratingHTML;
      const ratingEl = wrapper.firstElementChild;

      if (!ratingEl) {
        ErrorHandler.log(new Error('Failed to create rating element'), 'injectSummaryRating');
        return;
      }

      if (!price.parentNode) {
        ErrorHandler.log(new Error('Price element has no parent'), 'injectSummaryRating');
        return;
      }

      // Add click-to-scroll
      ratingEl.style.cursor = 'pointer';
      ratingEl.addEventListener('click', () => {
        const testimonialSection = document.querySelector('#testimonial-section');
        if (testimonialSection) {
          testimonialSection.scrollIntoView({
            behavior: 'smooth'
          });
        }
      });

      // Insert rating above price
      price.parentNode.insertBefore(ratingEl, price);

      // Apply styles with matching spacing
      ratingEl.style.marginBottom = '16px';
      ratingEl.style.marginTop = '0';
      ratingEl.style.alignSelf = 'flex-start';

      console.log(`[${EXPID}] Rating injected successfully`);
    }, 'injectSummaryRating');
  }

  // Enhanced review section injection with error handling
  function injectReviewSection() {
    return ErrorHandler.safeExecute(() => {
      if (document.querySelector('#testimonial-section')) return;

      const reviewHTML = createReviewSection();
      if (!reviewHTML) return;

      const section = document.createElement('div');
      section.innerHTML = reviewHTML;
      const content = section.firstElementChild;

      if (!content) {
        ErrorHandler.log(new Error('Failed to create review section'), 'injectReviewSection');
        return;
      }

      // Try different injection points
      const brandSection = document.querySelector('.brand-partners');
      const footer = document.querySelector('footer, .footer-group, #shopify-section-footer-group');
      const mainContent = document.querySelector('#MainContent');

      let injected = false;

      if (brandSection && brandSection.parentNode) {
        brandSection.parentNode.insertBefore(content, brandSection.nextSibling);
        injected = true;
      } else if (footer && footer.parentNode) {
        footer.parentNode.insertBefore(content, footer);
        injected = true;
      } else if (mainContent) {
        mainContent.appendChild(content);
        injected = true;
      }

      if (!injected) {
        ErrorHandler.log(new Error('No suitable injection point found'), 'injectReviewSection');
        return;
      }

      // Equalize card heights with error handling
      setTimeout(() => {
        ErrorHandler.safeExecute(() => {
          const cards = document.querySelectorAll('.' + EXPID + '-review-card');
          if (cards.length === 0) return;

          let maxHeight = 0;
          cards.forEach(card => {
            card.style.height = 'auto';
            maxHeight = Math.max(maxHeight, card.offsetHeight);
          });
          cards.forEach(card => card.style.height = maxHeight + 'px');
        }, 'card height equalization');
      }, 200);

      console.log(`[${EXPID}] Review section injected successfully`);
    }, 'injectReviewSection');
  }

  // Enhanced observer setup
  function setupObserver() {
    return ErrorHandler.safeExecute(() => {
      const content = document.querySelector('#MainContent');
      if (!ErrorHandler.validateElement(content, '#MainContent', 'setupObserver')) return;

      const observer = new MutationObserver(() => {
        ErrorHandler.safeExecute(() => {
          const newPrice = document.querySelector('.price.price--large');
          const ratingExists = document.querySelector('.' + BLOCK_CLASS);

          if (newPrice && !ratingExists) {
            injectSummaryRating(newPrice);
            fixPriceLayout(); // Call fixPriceLayout here as well
          }
        }, 'observer callback');
      });

      observer.observe(content, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });

      console.log(`[${EXPID}] Observer setup successfully`);
      return observer;
    }, 'setupObserver');
  }

  // Main initialization function
  function initialize() {
    console.log(`[${EXPID}] Initializing...`);

    // Inject review section
    waitFor('#MainContent', () => {
      injectReviewSection();
    });

    // Inject rating and fix price layout
    waitFor('.price.price--large', (priceEl) => {
      injectSummaryRating(priceEl);
      fixPriceLayout(); // Ensure this is called
      setupObserver();
    });

    // Fallback mechanism with error handling
    const fallbackInterval = setInterval(() => {
      ErrorHandler.safeExecute(() => {
        const price = document.querySelector('.price.price--large');
        const ratingExists = document.querySelector('.' + BLOCK_CLASS);
        const plusSeparator = document.querySelector('.price-plus-seperator');
        const motivPrice = document.querySelectorAll('.price.price--large')[1];
        const motivLabel = document.querySelector('.motiv-price-label');

        if (price && !ratingExists) {
          injectSummaryRating(price);
        }

        // Re-run fixPriceLayout if the elements are not correctly positioned
        if (price && plusSeparator && motivPrice && motivLabel && (plusSeparator.style.display === 'none' || motivPrice.style.display === 'none' || motivLabel.style.display === 'none')) {
          fixPriceLayout();
        }

      }, 'fallback interval');
    }, 3000);

    // Cleanup fallback after 5 minutes to prevent memory leaks
    setTimeout(() => {
      clearInterval(fallbackInterval);
      console.log(`[${EXPID}] Fallback interval cleared`);
    }, 300000);

    console.log(`[${EXPID}] Initialization complete`);
  }

  // Global error handler
  window.addEventListener('error', (event) => {
    if (event.filename && event.filename.includes(EXPID)) {
      ErrorHandler.log(event.error, 'global error handler');
    }
  });

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();